var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from "@consta/uikit/Layout";
import { Loader } from "@consta/uikit/Loader";
import styles from "./CustomLoader.module.scss";
import cn from "classnames";
var CustomLoader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "m" : _b, className = _a.className;
    return (_jsx(Layout, __assign({ className: cn(styles.loader, className) }, { children: _jsx(Loader, { size: size }) })));
};
export default CustomLoader;
